
export default {
  'navbar.lang': 'العربية',
  'menu.home': 'الرئيسية',
  'menu.dashboard': 'لوحة التحكم',
  'menu.profile': 'الملف الشخصي',
  'menu.settings': 'الإعدادات',

  'user.login.title': 'نجحت عملية المسح!',
  'user.login.subtitle': 'قدم بياناتك للمتابعة',
  'user.login.username': 'اسم المستخدم أو البريد الإلكتروني',
  'user.login.password': 'كلمة المرور',
  'user.login.forgot': 'نسيت كلمة المرور؟',
  'user.login.button': 'تسجيل الدخول',

  'user.register.title': 'إنشاء حساب جديد',
  'user.register.button': 'سجل',
  'user.register.success': 'تم إنشاء الحساب. تحقق من بريدك الإلكتروني للتأكيد.',

  'user.login.welcome.subheading': 'مرحبًا بك في عالم تلتقي فيه الحرية بالحياة الفريدة! امسح. اكسب نقاطًا. عش بحرية. عش بشكل فريد',
  'user.login.description': 'لقد قمت بمسح رمز QR بنجاح. قم بتسجيل الدخول أو التسجيل أدناه للمطالبة بالمكافآت والنقاط والفوز بجوائز رائعة',
  'user.login.signin.title': 'تسجيل الدخول',
  'user.login.signin.sub': 'للتسجيل، الرجاء إدخال رقم هاتفك؛ سنرسل رمز التحقق',
  'user.login.phoneNumberLabel': 'رقم الهاتف',
  'user.login.enterPhonePlaceholder': 'أدخل رقم الهاتف',
  'user.login.invalidPhone': 'رقم هاتف غير صالح',
  'user.login.phoneRequired': 'رقم الهاتف مطلوب',
  'user.login.signingIn': 'جار تسجيل الدخول...',
  'user.login.continue': 'متابعة',
  'user.login.noAccount': 'ليس لديك حساب؟',
  'user.login.signup': 'سجل',
  'user.login.footerCopyright': 'حقوق النشر © {year}. مقدم من Exceptional Brands',

  'user.register.welcome': 'مرحبًا!',
  'user.register': 'سجل للمطالبة بمكافآتك',
  'user.register.description': 'أكمل بياناتك أدناه لكسب النقاط وفتح المكافآت والفوز بجوائز رائعة',
  'user.register.phone.label': 'رقم الهاتف',
  'user.register.phone.placeholder': 'أدخل رقم الهاتف',
  'user.register.phone.required': 'رقم الهاتف مطلوب',
  'user.register.phone.invalid': 'رقم هاتف غير صالح',
  'user.register.name.label': 'اسمك',
  'user.register.name.placeholder': 'مثال: Mark',
  'user.register.name.required': 'الاسم مطلوب',
  'user.register.ageGroup.label': 'الفئة العمرية (اختياري)',
  'user.register.gender.label': 'الجنس (اختياري)',
  'user.register.gender.male': 'ذكر',
  'user.register.gender.female': 'أنثى',
  'user.register.terms.agreement': 'بالمتابعة، فإنك توافق على {termsLink} و {privacyLink} الخاصين بنا.',
  'user.register.terms.termsOfService': 'شروط الخدمة',
  'user.register.terms.privacyPolicy': 'سياسة الخصوصية',
  'user.register.creating': 'جار إنشاء الملف الشخصي…',
  'user.register.create': 'إنشاء الملف الشخصي',
  'user.register.alreadyAccount': 'هل لديك حساب بالفعل؟',
  'user.register.signin': 'تسجيل الدخول',
  'user.register.footer.copyright': 'حقوق النشر © {year}. مقدم من Exceptional Brands',

  "user.welcome.welcome": "مرحبًا!",
  "user.welcome.welcome_name": "مرحبًا {name}!",
  'user.welcome.points_earned': 'تهانينا، لقد حصلت على',
  'user.welcome.thank_you': 'شكرًا لتسجيلك!',
  'user.welcome.earn_more_points': 'للحصول على مزيد من النقاط، قم بتقييم المزيد من المنتجات التي اشتريتها منا.',
  'user.welcome.continue': 'متابعة',
  'user.welcome.logging_in': 'جار تسجيل الدخول...',
  "user.welcome.welcome_reward": "مكافأة الترحيب",
  "user.welcome.points_label": "نقطة!",

  "product.button.continue": "متابعة",
  "product.button.selectToContinue": "اختر منتجًا للمتابعة",

  'scansuccess.review.heading': 'كيف تقيم هذا المنتج؟',
  'scansuccess.review.continue': 'رمز البائع (اختياري)',
  'scansuccess.review.select-product': 'أضف رمز البائع لكسب المزيد من النقاط',
  'scansuccess.review.review-products': 'إرسال التقييم',

  "product.retailerCode.label": "رمز البائع",
  "product.retailerCode.requiredLabel": "مطلوب",
  "product.retailerCode.optionalLabel": "اختياري",
  "product.retailerCode.placeholder": "أدخل رمز البائع",
  "product.retailerCode.aria": "رمز البائع",
  "product.retailerCode.hintRequired": "رمز البائع مطلوب لإرسال هذا التقييم",
  "product.retailerCode.hintOptional": "أضف رمز البائع لكسب المزيد من النقاط",
  "product.retailerCode.error.required": "رمز البائع مطلوب",
  "product.retailerCode.error.invalid": "رمز البائع غير صالح",

  "profile.title": "ملفي الشخصي",
  "profile.tier.member": "عضو",
  "profile.points": "النقاط",
  "profile.pointsEarned": "النقاط المكتسبة",
  'scansuccess.continue': 'متابعة',
  "profile.completeTitle": "أكمل ملفك الشخصي",
  "profile.completeSubtitle": "اكسب {points} نقاطًا إضافية!",
  "profile.completedTitle": "اكتمل الملف الشخصي! ✓",
  "profile.completedSubtitle": "لقد ربحت جميع {points} النقاط الإضافية!",
  "profile.completeButton": "أكمل الملف (+{points} pt)",
  "profile.redeem": "✓ الملف الشخصي مكتمل",
  "product.review.placeholder": "اكتب مراجعة... (حرف واحد يكفي)",
  "product.review.ariaLabel": "اكتب مراجعة",
  "profile.field.phoneNo.label": "رقم الهاتف",
  "profile.field.phoneNo.add": "أضف رقم هاتفك",
  "profile.field.email.label": "البريد الإلكتروني",
  "profile.field.email.add": "أضف بريدك الإلكتروني",
  "profile.field.countryCode.label": "الموقع",
  "profile.field.countryCode.add": "أضف موقعك",
  "profile.field.name.label": "الاسم",
  "profile.field.name.add": "أضف اسمك",
  "profile.field.dateOfBirth.label": "تاريخ الميلاد",
  "profile.field.dateOfBirth.add": "أضف تاريخ ميلادك",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "تحديث {field}",
  "profile.modal.completeTitle": "أكمل ملفك الشخصي",
  "profile.modal.update": "تحديث",
  "profile.modal.complete": "أكمل الملف",
  "profile.modal.cancel": "إلغاء",
  "profile.completedBadge": "لقد ربحت {points} نقاط",
  "profile.progressPercent": "{percent}% مكتمل",
  "profile.progressRemaining": "{percent}% متبقي",
  'scansuccess.congratulations.heading': 'تهانينا!',
  'scansuccess.congratulations.continue': 'لقد حصلت على',
  'scansuccess.congratulations.select-product': 'شكرًا لمراجعتك',
  'scansuccess.congratulations.review-products': 'للحصول على مزيد من النقاط، قم بتقييم المزيد من المنتجات التي اشتريتها منا',
  'scansuccess.congratulations.create': 'اذهب إلى لوحة القيادة',
  'user.brand-product-review.title': 'اختر العلامة التجارية والمنتج للمتابعة',
  'user.brand-product-review.continue': 'متابعة',
  'user.brand-product-review.select-product': 'اختر منتجًا للمتابعة',
  'user.brand-product-review.review-products': 'قم بمراجعة منتجاتنا للحصول على نقاط',
  'user.brand-product-review.rate-product': 'يرجى تقييم منتج واحد على الأقل أعلاه للمتابعة',
  'user.brand-product-review.footer': 'حقوق النشر © {year}. مقدم من Exceptional Brands',
  'scansuccess.title': 'نتائج المسح',
  'scansuccess.scan.message': 'شكرًا — تم المسح بنجاح.',
  'scansuccess.scan.instructions': 'يمكنك المطالبة بالنقاط، كتابة مراجعة أو التسجيل للحصول على عروض.',
  'scansuccess.signup.title': 'سجل للمطالبة بالمكافآت',
  'scansuccess.signup.button': 'سجل',
  'scansuccess.welcomepoints.title': 'نقاط الترحيب',
  'scansuccess.welcomepoints.pointsLabel': 'النقاط الممنوحة',
  'scansuccess.brandproductreview.title': 'مراجعة العلامة التجارية والمنتج',
  'scansuccess.brandproductreview.leaveReview': 'اترك مراجعة',
  'scansuccess.productreview.title': 'مراجعة المنتج',
  'scansuccess.productreview.submit': 'إرسال المراجعة',
  'scansuccess.congratulations.title': 'تهانينا!',
  'scansuccess.congratulations.message': 'لقد ربحت نقاطًا — تحقق من لوحة التحكم للمطالبة.',
  'scansuccess.noAccount': 'ليس لديك حساب؟',
  'scansuccess.signup': 'سجل',

  "user.register.createProfile": "إنشاء حساب",
  "user.register.creatingProfile": "جار إنشاء الحساب...",
  "user.register.termsOfService": "شروط الخدمة",
  "user.register.privacyPolicy": "سياسة الخصوصية",

  'dashboard.multiplescans.title': 'مسحات متعددة',
  'dashboard.multiplescans.instructions': 'إدارة مسحات متعددة والمكافآت معًا.',
  'dashboard.title': 'مرحبًا!',
  'dashboard.balance': 'رصيدك',
  'dashboard.balance-sub': 'نقاط',
  'dashboard.redeem': 'استرداد',
  'dashboard.stat': 'إجمالي المسحات',
  'dashboard.label': 'المكافآت المحققة',
  'dashboard.redeem.title': 'استرد نقاطك',
  'dashboard.redeem.success': 'استرد المكافآت',
  'dashboard.primary-sub': 'استخدم نقاطك لفتح المكافآت',
  'dashboard.secondary-btn': 'مسح مرة أخرى',
  'dashboard.secondary': 'الإحالة لصديق',
  'dashboard.loyalty': 'مستويات الولاء',
  'dashboard.5000pts': '5000 نقطة',
  'dashboard.100pts': '100 نقطة إلى بلاتين',
  'dashboard.almost-there': 'قريبًا!',
  'dashboard.recent': 'النشاط الأخير',
  'settings.title': 'الإعدادات',
  'settings.balance': 'عضو ذهبي',
  'settings.balance-sub': 'نقاط',
  'settings.redeem': 'الحساب',
  'settings.stat': 'تحرير الملف الشخصي',
  'settings.label': 'تحديث المعلومات الشخصية',
  'settings.redeem.title': 'التفضيلات',
  'settings.redeem.success': 'الإشعارات',
  'settings.primary-sub': 'تفضيلات الإشعارات والبريد الإلكتروني',
  'settings.secondary-btn': 'اللغة',
  'settings.secondary': 'العربية',
  'settings.loyalty': 'المساعدة والشروط',
  'settings.5000pts': 'المساعدة والدعم',
  'settings.100pts': 'الأسئلة المتكررة، تواصل معنا',
  'settings.almost-there': 'الأحكام والشروط',
  'settings.recent': 'المعلومات القانونية',
  'settings.points': 'سياسة الخصوصية',
  'settings.data': 'معلومات حماية البيانات',
  'settings.sign': 'تسجيل الخروج',

  'profile.balance': '% مكتمل',
  'profile.balance-sub': '% المتبقي',
  'profile.stat': 'معلومات الملف الشخصي',
  'profile.label': 'نقطة',
  'profile.redeem.title': 'ربط وسائل التواصل الاجتماعي',
  'profile.redeem.success': 'اكسب نقاطًا عند كل ربط!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 نق',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 نق',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 نق',
  'profile.almost-there': 'اربط وسائل التواصل الخاصة بك للحصول على بونص 20 نقطة!',
  'profile.recent': 'املأ الحقول التالية لإكمال ملفك الشخصي وكسب ',


  "country.KE": "كينيا",
  "country.ZW": "زيمبابوي",
  "country.ZA": "جنوب أفريقيا",
  "country.BJ": "بنين",
  "country.AE": "الإمارات العربية المتحدة",

  "dashboard.welcome": "مرحبًا!",
  "dashboard.user.unknown": "مستخدم",
  "dashboard.balanceLabel": "رصيدك",
  "dashboard.coinsAlt": "عملات",
  "dashboard.pointsLabel": "نقاط",
  "dashboard.redeemBtn": "استخدم النقاط",
  "dashboard.totalScans": "إجمالي المسحات",
  "dashboard.rewardsWon": "المكافآت المحققة",
  "dashboard.redeemTitle": "استرد نقاطك",
  "dashboard.redeemRewards": "استرد المكافآت",
  "dashboard.redeemSub": "استخدم نقاطك لفتح المكافآت",
  "dashboard.reviewProducts": "مراجعة المنتجات",
  "dashboard.referFriend": "أحِل صديق",
  "dashboard.tiersTitle": "مستويات الولاء",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "قريبًا!",
  "dashboard.recentActivityTitle": "النشاط الأخير",
  "dashboard.share.title": "انضم إلى Exceptional Brands",
  "dashboard.share.text": "انضم إلي على Exceptional Brands! اكسب النقاط عن طريق مسح المنتجات واحصل على مكافآت مدهشة. استخدم رابط الإحالة الخاص بي: {url}",
  "dashboard.shareModalTitle": "شارك مع الأصدقاء",
  "dashboard.shareModalDesc": "شارك Exceptional Brands مع أصدقائك واحصل على نقاط إضافية عندما ينضمون!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "رابط الإحالة الخاص بك:",
  "dashboard.share.instagramCopied": "تم نسخ الرابط إلى الحافظة - ألصقه في إنستغرام",
  "dashboard.footerCopyright": "حقوق النشر © {year}. مقدم من Exceptional Brands",
  "dashboard.aria.welcome": "لوحة الترحيب",
  "dashboard.aria.notifications": "الإشعارات",
  "dashboard.aria.settings": "الإعدادات",
  'dashboard.redeem.points': 'استرد نقاطك',
  'dashboard.redeem.subtitle': 'استخدم نقاطك لفتح المكافآت',
  'dashboard.redeem.sub': 'نقاط',
  'dashboard.redeem.progress': 'التقدم نحو Platinum',
  'dashboard.redeem.stat': 'المكافآت المتاحة',
  'dashboard.redeem.label': 'استرد',
  'dashboard.redeem.need': 'مطلوب',
  'dashboard.redeem.prize': 'تحميل الجائزة',
  'dashboard.redeem.scan': 'كلما مسحت أكثر زادت فرصك في الفوز بشيء رائع',
  'dashboard.redeem.recent': 'النشاط الأخير',
  'global.back': 'عودة',
  'global.next': 'التالي',
  'global.search.placeholder': 'بحث...',
  'validation.required': 'هذا الحقل مطلوب',
  'error.404.title': 'الصفحة غير موجودة',
  'error.404.subTitle': 'عذرًا، لا يمكننا العثور على الصفحة التي تبحث عنها.',
};
